module.exports = __webpack_public_path__ + "img/music-work-icon12.66c0cd7c.png";